// Plugins are loaded alphabetically. We start the file name with 1_ to begin fetch-patch as soon as possible.
import { defineNuxtPlugin } from "nuxt/app";
import { useServerLogger } from "~/composables/useServerLogger";

export default defineNuxtPlugin(() => {
  if (process.client) {
    // --- 1. Intercept fetch to catch Raygun errors ---
    if (typeof window !== "undefined" && window.fetch) {
      const originalFetch = window.fetch;

      window.fetch = async (...args) => {
        const url = args[0]?.toString?.() || "";
        const isRaygunApi = url.includes("api.raygun.io/ping");

        if (isRaygunApi) {
          try {
            const response = await originalFetch(...args);
            if (response.status >= 400) {
              await useServerLogger(
                new Error("Raygun API error"),
                "Raygun API request failed",
                {
                  url,
                  status: response.status,
                },
              );
            }

            return response;
          } catch (err) {
            await useServerLogger(
              err as Error,
              "Raygun fetch failed due to network error",
              { url },
            );
          }
        }
        return originalFetch(...args);
      };
    }
  }
});
